// removed by extract-text-webpack-plugin
module.exports = {"container":"RecordingsListItemView-container","headerLegend":"RecordingsListItemView-headerLegend"};